import React from 'react'
import {toAbsoluteUrl} from '../../../_Montdor/helpers'

type Props = {
  loading: boolean
  length: number
  colSpan: number
}

const BlankDataImageInTable: React.FC<Props> = ({loading, length, colSpan}) => {
  if (length > 0 || loading) return null

  return (
    <tr>
      <td colSpan={colSpan} style={{border: 'none', padding: '32px 16px'}}>
        <div style={{
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center', gap: 12,
        }}>
          <div style={{
            width: 56, height: 56, borderRadius: '50%',
            background: 'linear-gradient(135deg, #F1F5F9, #E2E8F0)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 26,
          }}>
            📭
          </div>
          <div style={{textAlign: 'center'}}>
            <p style={{
              fontSize: 14, fontWeight: 600, color: '#334155', margin: 0,
            }}>
              No records found
            </p>
            <p style={{fontSize: 12, color: '#94A3B8', margin: '4px 0 0'}}>
              Try adjusting your search or filters
            </p>
          </div>
        </div>
      </td>
    </tr>
  )
}

export default BlankDataImageInTable
